/* eslint-disable camelcase, max-len */
import { Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";

import EclipseChart from "../components/EclipseChart";
import NextPrevLinks from "../../components/NextPrevLinks";
import SectionIntroduction from "../components/SectionIntroduction";
import SelfOtherOrientationAssessment from "../components/SelfOtherOrientationAssessment";
import { useMemo } from "react";
import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext";

const SelfOther = ({ showHeader }) => {
	const { respondent } = useUser();
	const { reportContent: { acf: { self_other } } } = useReport();

	const stats = useMemo(() => respondent?.weqProfile?.stats, [respondent]);

	return (
		<>
			{showHeader ? <><h1>Your Self-Other Orientation</h1><hr /></> : null}
			<div className="report-view">
				<SectionIntroduction
					text={self_other.introduction}
					videoUrl={`https://fast.wistia.net/embed/iframe/wchyv75fz6`}
				/>
				
				<hr />

				<Row lg={2} xs={1}>
					<Col className="order-1 order-lg-0">
						<SelfOtherOrientationAssessment />
					</Col>
					<Col className="order-0 order-lg-1 mb-4">
						<Card body className="bg-white position-sticky sticky-top">
							<EclipseChart
								percentile={respondent?.weqProfile?.percentiles?.self_Other_Focus_Balance}
								target="Target Focus - 50/50"
								values={[
									{ label: "Focus on Self", value: stats?.self_Oriented_dist },
									{ label: "Focus on Other", value: stats?.other_Oriented_dist }
								]}
							/>
						</Card>
					</Col>
				</Row>

				<NextPrevLinks className="mt-4" />
			</div>
		</>
	);
};

SelfOther.propTypes = {
	showHeader: PropTypes.bool
};

SelfOther.defaultProps = {
	showHeader: false
}

export default SelfOther;
